import styled from 'styled-components'

import { SuccessButton } from 'components/common/Button/SuccessButton'
import { Color } from 'constants/color'

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const Input = styled.input`
    width: 300px;
    font-family: Avenir;
    height: 40px;
    padding: 8px;
    border: 1px solid ${Color.unknownColor17};
    border-radius: 8px;
`

export const Submit = styled(SuccessButton)`
    width: 100px;
    height: 40px;
    margin-top: 24px;

    color: ${Color.white};
`
